import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule, ModalController } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-info-modal',
  templateUrl: './info-modal.component.html',
  styleUrls: ['./info-modal.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule, TranslateModule]
})
export class InfoModalComponent implements OnInit {
  @Input() type: 'ride' | 'delivery' | 'driver' | 'rider' | 'store_order' = 'ride';
  @Input() data: any;
  @Input() currencySymbol: string = '$';

  constructor(private modalCtrl: ModalController) {}

  ngOnInit() {
    console.log('InfoModal initialized with type:', this.type, 'and data:', this.data);
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }

  liveTrack() {
    this.modalCtrl.dismiss({
      action: 'liveTrack',
      mission: this.data
    });
  }

  getStatusColor(status: string): string {
    if (!status) return 'medium';
    status = status.toLowerCase();
    if (status === 'done' || status === 'completed' || status === 'delivered' || status === 'approved') return 'success';
    if (status === 'pending' || status === 'waiting') return 'warning';
    if (status === 'cancelled' || status === 'rejected') return 'danger';
    if (status === 'started' || status === 'in_transit' || status === 'active' || status === 'preparing' || status === 'ready' || status === 'picked_up') return 'primary';
    return 'medium';
  }

  formatDate(timestamp: any): string {
    if (!timestamp) return 'N/A';
    // Handle Firestore timestamp or ISO string
    if (timestamp.toDate) {
      return timestamp.toDate().toLocaleString();
    }
    return new Date(timestamp).toLocaleString();
  }

  getDriverName(): string {
    if (this.type === 'ride') return this.data.driverDetails?.Driver_name || this.data.Driver_name || 'N/A';
    if (this.type === 'delivery') return this.data.driverName || 'N/A';
    return 'N/A';
  }

  getRiderName(): string {
    if (this.type === 'ride') return this.data.Rider_name || 'N/A';
    if (this.type === 'delivery') return this.data.senderName || 'N/A';
    if (this.type === 'store_order') return this.data.riderName || 'N/A';
    return 'N/A';
  }

  getVendorName(): string {
    return this.data.vendorName || 'N/A';
  }

  getCustomerPhone(): string {
    if (this.type === 'ride') return this.data.Rider_phone || 'N/A';
    if (this.type === 'delivery') return this.data.senderPhone || 'N/A';
    if (this.type === 'store_order') return this.data.riderPhone || 'N/A';
    return 'N/A';
  }
}
